import * as React from 'react';
import styled from 'styled-components';

import { COLORS, TYPOGRAPHY } from '../styles';

type SkipToContentProps = {};

const SkipToContentLink = styled.a`
  color: ${COLORS.black};
  font-weight: bold;
  font-size: 16px;
  font-family: ${TYPOGRAPHY.fontFamily};
  text-decoration: underline;
`;

const SkipToContentWrapper = styled.div`
  text-decoration: none;
  z-index: -1000;
  height: 0px;
  overflow-x: hidden;

  &:focus-within {
    height: auto;
    padding: 16px;
    z-index: 100000;

    background: ${COLORS.accent2_200};
  }

  @media print {
    display: none;
  }
`;

const SkipToContent: React.FunctionComponent<SkipToContentProps> = ({ children }) => {
  return (
    <SkipToContentWrapper>
      <SkipToContentLink href="#main">{children}</SkipToContentLink>
    </SkipToContentWrapper>
  );
};

export default SkipToContent;
